import { ContentControlledEditingDirectiveInstructions } from '../editing-directive/content-controlled-editing-directive-instructions';
import { ContentControlledEventActionEnum } from '../enums/content-controlled-event-action.enum';
import { IAIObjectDetectionClass } from '../ai/i-ai-object-detection-class';

export default class ContentControlAIObjectDetectionSettings {
  constructor(
    public id: string,
    public type: 'object_detection',
    public requiredClass: IAIObjectDetectionClass,
    public isEnabled: boolean = false,
    public isAutomaticMitigation: boolean = false,
    public automaticMitigationAction: ContentControlledEventActionEnum = ContentControlledEventActionEnum.Empty,
    public instructions: ContentControlledEditingDirectiveInstructions = new ContentControlledEditingDirectiveInstructions(),
    public expanded: boolean = false,
  ) {}
}
